import * as api from '@owl-nest/api-client/latest'
import * as models from '@owl-nest/models'

import type { ApiResponse } from '@owl-nest/api-client'

export async function add(
  project: models.project.ProjectForOwner | models.project.ProjectForStaff,
  payload: { tag: string; type: api.AllowedAnalyticsTag },
): Promise<
  ApiResponse<{
    id: number
    tag: string
    type: api.AllowedAnalyticsTag
  }>
> {
  const response = await api.api.post.projectAnalytics({
    urlParams: { projectId: String(project.id) },
    body: payload,
  })

  return response.next((success) => success.body)
}

export async function remove(analyticsTagId: number): Promise<ApiResponse<void>> {
  const response = await api.api.delete.analyticsTag({
    urlParams: { analyticsTagId: String(analyticsTagId) },
  })

  return response.next((success) => success.body)
}
